import type { FaireProductEntity } from "../../entity_types/product";

export const p_3umfsujwrc: FaireProductEntity = {
  token: "p_3umfsujwrc",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Rhodolite",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/66b7e92c072e198a07ff90964147946910a2bff62c61269dae8e57e301dad87a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc3e7b3bedec023f20578bb1ffcc5d2ba9d4e68dbcf3007250360f1cafdce6b2.jpeg",
    "https://cdn.faire.com/fastly/d4d524b283fb96332a3e054d17032d0ee07ff6eb544c2a496d9ffedf03f8ead9.jpeg",
    "https://cdn.faire.com/fastly/540efed7b087f0fb9ae32f620323043092d1a9d07115f92cdbbdec7a58e3dddd.png",
    "https://cdn.faire.com/fastly/c2b8fe9b469c0b857153406265c569bd704277086054771e34eaa85a31a81ac4.jpeg",
    "https://cdn.faire.com/fastly/94a9d2ce55514f08d8358c800606f201896391c89ee8292490b3fafd0dbdb3e2.jpeg",
    "https://cdn.faire.com/fastly/f6def2fdcefa5ce154e7f8999d1b446b20e9807181185dbba6b91f23ebb79b3a.jpeg",
    "https://cdn.faire.com/fastly/c4098febd740180a3a270a03d5fd7d05814f4c834e9137eef7031a5d255a5e52.jpeg",
    "https://cdn.faire.com/fastly/cff01ca307ce60e288807072fbf93b4b73e99e61d071b0792e9a54c2992e76e0.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee, built on a bold jacquard grid — the pattern is knitted in, never printed on top. Lightweight, breathable, and easy to style.\n\n * Slightly cropped and boxy body \n * 100% cotton \n * Made in Lima, Peru, with knitwear specialists we have worked with for years — Fair Trade certified ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:26.052Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
